export default __webpack_public_path__ + "static/media/mobile security.733096ad.png";